import React from 'react';
import { GRADIENT_COLORS, GRADIENT_ID, GRADIENT_STOPS } from '../constants';

/**
 * Chart gradient definition component for area chart fill
 * Uses proper coordinates for Y-axis that doesn't start from 0
 */
export const ChartGradient: React.FC = () => (
  <defs>
    <linearGradient
      id={GRADIENT_ID}
      x1="0%"
      y1="100%"
      x2="0%"
      y2="0%"
      gradientUnits="objectBoundingBox"
    >
      <stop
        offset={GRADIENT_STOPS.START}
        stopColor={GRADIENT_COLORS.END}
        stopOpacity="1"
      />
      <stop
        offset={GRADIENT_STOPS.MIDDLE}
        stopColor={GRADIENT_COLORS.MIDDLE}
        stopOpacity="1"
      />
      <stop
        offset={GRADIENT_STOPS.END}
        stopColor={GRADIENT_COLORS.START}
        stopOpacity="1"
      />
    </linearGradient>
  </defs>
);
